import styled from 'styled-components';

export const PageItem = styled.li.attrs({ className: 'PageItem' })`
  display: inline;
  a {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    padding: 50px;

    touch-action: manipulation;
    text-decoration: none;

    &:hover {
      color: #4db2ec;
      text-decoration: none;
    }

    &.active {
      z-index: 2;
      color: #4db2ec;
    }

    &.first {
      margin-left: 0;
      border-bottom-left-radius: 0.25rem;
      border-top-left-radius: 0.25rem;
    }

    &.last {
      border-bottom-right-radius: 0.25rem;
      border-top-right-radius: 0.25rem;
    }
  }

  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  font-family: 'Roboto', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  color: #b3b3b3;
  cursor: pointer;
`;
